import React from 'react';
import Chart from 'react-apexcharts';

const APIUsageTrend = ({ data }) => {
    const options = {
        chart: { type: 'area', toolbar: { show: false } },
        xaxis: { categories: data.map(d => d._id) },
        colors: ['#3498db'],
        dataLabels: { enabled: false },
        stroke: { curve: 'smooth' }
    };

    const series = [{ name: 'API Calls', data: data.map(d => d.calls) }];

    return (
        <div className="chart-card">
            <h3>API Usage Trend</h3>
            <Chart options={options} series={series} type="area" height={300} />
        </div>
    );
};

export default APIUsageTrend;
